import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import "@/App.css";

import Login from "@/pages/Login";
import Setores from "@/pages/Setores";
import ComplianceDashboard from "@/pages/Compliance";
import { OcorrenciasList, NovaOcorrencia } from "@/pages/Ocorrencias";
import ProcessoDetalhe from "@/pages/ProcessoDetalhe";
import Documentos from "@/pages/Documentos";
import Orcamentos from "@/pages/Orcamentos";
import CanalDenuncia from "@/pages/CanalDenuncia";
import AdminUsuarios from "@/pages/AdminUsuarios";
import SgoClientes from "@/pages/SgoClientes";
import SgoOrcamentos from "@/pages/SgoOrcamentos";
import SgoNovoOrcamento from "@/pages/SgoNovoOrcamento";
import RhFichaColaborador from "@/pages/RhFichaColaborador";
import Financeiro from "@/pages/Financeiro";
import Juridico from "@/pages/Juridico";
import TI from "@/pages/TI";
import Marketing from "@/pages/Marketing";
import Atendimento from "@/pages/Atendimento";
import Documentacao from "@/pages/Documentacao";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0A0B1A]"><Loader2 className="animate-spin text-[#B28F4B]"/></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#131532",
                border: "1px solid rgba(178,143,75,0.3)",
                color: "#fff",
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/canal-denuncia" element={<CanalDenuncia />} />

            <Route path="/setores" element={<Protected><Setores /></Protected>} />
            <Route path="/compliance" element={<Protected><ComplianceDashboard /></Protected>} />
            <Route path="/compliance/ocorrencias" element={<Protected><OcorrenciasList /></Protected>} />
            <Route path="/compliance/ocorrencias/nova" element={<Protected><NovaOcorrencia /></Protected>} />
            <Route path="/compliance/processos/:id" element={<Protected><ProcessoDetalhe /></Protected>} />
            <Route path="/documentos" element={<Protected><Documentos /></Protected>} />
            <Route path="/orcamentos" element={<Protected><Orcamentos /></Protected>} />
            <Route path="/sgo/clientes" element={<Protected><SgoClientes /></Protected>} />
            <Route path="/sgo/orcamentos" element={<Protected><SgoOrcamentos /></Protected>} />
            <Route path="/sgo/orcamentos/novo" element={<Protected><SgoNovoOrcamento /></Protected>} />
            <Route path="/rh" element={<Protected><RhFichaColaborador /></Protected>} />
            <Route path="/financeiro" element={<Protected><Financeiro /></Protected>} />
            <Route path="/administrativo" element={<Protected><Juridico /></Protected>} />
            <Route path="/ti" element={<Protected><TI /></Protected>} />
            <Route path="/marketing" element={<Protected><Marketing /></Protected>} />
            <Route path="/atendimento" element={<Protected><Atendimento /></Protected>} />
            <Route path="/documentacao" element={<Documentacao />} />
            <Route path="/admin/usuarios" element={<Protected><AdminUsuarios /></Protected>} />

            <Route path="/" element={<Navigate to="/setores" replace />} />
            <Route path="*" element={<Navigate to="/setores" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
